import React from 'react';

interface LogoProps {
  /** Pixel size of the (square) mark. Defaults to 40. */
  size?: number;
  /** Extra classes (margins, etc.). */
  className?: string;
}

// One pen stroke: a P whose bowl loops past where it started.
const P = 'M38 82 V30 C38 20 72 18 72 39 C72 58 42 60 36 49 C33 43 40 38 46 40';

/**
 * The PaperBrain mark — a one-stroke P beside a violet margin rule on plain
 * paper. Drawn inline from the same geometry as brand/mark*.svg (the source of
 * the favicons and app icons), so it stays crisp at any size.
 *
 * Below 48px the small-size drawing takes over: heavier P and a longer, bolder
 * margin so both survive favicon sizes (same as brand/mark-small.svg).
 */
export const Logo: React.FC<LogoProps> = ({ size = 40, className }) => {
  const small = size < 48;
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      role="img"
      aria-label="PaperBrain"
      className={['shrink-0', className].filter(Boolean).join(' ')}
    >
      <rect width="100" height="100" rx="22" fill="#faf8f4" />
      {small ? (
        <>
          <path d="M17 12 V88" stroke="#5b3fd0" strokeWidth="6" strokeLinecap="round" />
          <path
            d={P}
            transform="translate(4 0)"
            fill="none"
            stroke="#1c1b19"
            strokeWidth="11"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : (
        <>
          <path d="M19 16 V84" stroke="#5b3fd0" strokeWidth="7" strokeLinecap="round" />
          <path
            d={P}
            transform="translate(4 0)"
            fill="none"
            stroke="#1c1b19"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  );
};
